// src/contexts/I18nContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setI18n } from '../reduxStore/modules/common';

// Create a more robust default translator
const defaultTranslator = (key) => {
  if (typeof key === 'string') {
    return key;
  }
  return '';
};

const defaultI18n = {
  t: defaultTranslator
};

const I18nContext = createContext(defaultI18n);

export const I18nProvider = ({ children }) => {
  const dispatch = useDispatch();
  const reduxI18n = useSelector(state => state.common.i18n);
  const [i18n, setLocalI18n] = useState(defaultI18n);

  // Initialize i18n from window.i18n if available
  useEffect(() => {
    if (window.i18n && typeof window.i18n.t === 'function') {
      setLocalI18n(window.i18n);
      dispatch(setI18n(window.i18n));
    } else if (reduxI18n && typeof reduxI18n.t === 'function') {
      setLocalI18n(reduxI18n);
    } else {
      // Set default i18n in Redux
      dispatch(setI18n(defaultI18n));
    }
  }, [dispatch]);

  // Keep the context updated with Redux state
  useEffect(() => {
    if (reduxI18n && typeof reduxI18n.t === 'function') {
      setLocalI18n(reduxI18n);
    }
  }, [reduxI18n]);

  return (
    <I18nContext.Provider value={i18n}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => {
  const context = useContext(I18nContext);
  if (!context || typeof context.t !== 'function') {
    return defaultI18n;
  }
  return context;
};